import React from 'react';
import PropTypes from 'prop-types';
import {Space} from 'antd';
import {
  StyledBudgetPreviewLegendAmount,
  StyledBudgetPreviewLegendDot,
  StyledBudgetPreviewLegendTitle,
} from './StyledBudgetPreviewLegend';
import {amountHelpers} from '../../../../utils/helpers';

const BudgetPreviewLegend = ({
  amount = 0,
  color,
  title,
  ...rest
}) => {
  return (
    <Space size='small' direction='horizontal' {...rest}>
      <Space size={4}>
        <StyledBudgetPreviewLegendDot color={color} />
        <StyledBudgetPreviewLegendTitle>{title}</StyledBudgetPreviewLegendTitle>
      </Space>
      <StyledBudgetPreviewLegendAmount>
        {amountHelpers.getAmountWithCurrencyCode(amount)}
      </StyledBudgetPreviewLegendAmount>
    </Space>
  )
};

BudgetPreviewLegend.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  title: PropTypes.string,
};

export default BudgetPreviewLegend;
